export default {
	campaignPeriod: {
		title: 'Période de la campagne',
		button: {
			downloadGuide: 'Télécharger le guide de la campagne (.pdf, 4Mo)',
			confirm: 'Terminer la campagne',
			start: 'Démarrer la campagne',
			end: 'Terminer la campagne'
		},
		tooltip: 'Vous devez mener votre campagne sur une durée minimale de deux semaines',
		alert: 'Le délai nécessaire à la tenue de la campagne a été dépassé',
		startPopUp: {
			title: 'Êtes-vous sûr de vouloir démarrer votre campagne ?',
			content: 'Cette action est irréversible. Vous ne pourrez pas revenir en arrière.'
		},
		closePopUp: {
			title: 'Êtes-vous sûr de vouloir terminer la campagne ?',
			boldcontent: 'Avez-vous renseigné le nombre de patients éligibles pour chaque semaine ?',
			content: 'La clôture est irréversible, aucune réponse aux questionnaires ne sera prise en compte passé cette action'
		},
		chip: {
			project: '✓ Participation effectuée'
		},
		beforStartTexts: {
			beforeOpeningText: 'Vous pourrez démarrer votre participation à partir du premier jour d\'ouverture de la campagne nationale',
			openingText: 'Les liens vers le questionnaire ne seront actifs qu\'à partir du lancement de la campagne. Assurez-vous d\'avoir cliqué sur "Démarrer la campagne"'
		},
		urls: {
			guide: '/api/projects/{projectToken}/survey-campaign/{reference}/file/guide',
			pdfFile: '/api/projects/{projectToken}/survey-campaign/{reference}/channel/{channelType}'
		}
	},
	campaignChannels: {
		title: 'Canaux de communication',
		channelCard: {
			channelLabel: 'via {channelLabel}',
			cardButton: {
				action: {
					download: 'Télécharger le {channelAction}',
					import: 'Import',
					mailto: 'Afficher le {channelAction}'
				}
			},
			mailTemplate: {
				popUpHeader: 'Template mail de transmission du questionnaire',
				copyContent: 'Copier le contenu',
				copySubject: 'Copier l\'objet',
				object: 'Objet'
			},
			warningTitle: 'Attention !',
			warningMessage: 'La fonctionnalité d\'import de listes mail est accessible lorsque votre campagne est en cours.',
			btnText: 'J\'ai compris',
			downloadedFileSuccessMessage: 'Le PDF est téléchargé avec succès.'
		}
	}
};
